import { SearchIcon } from '@stockx/icons';
import {
  CloseButton,
  Input,
  InputLeftElement,
  InputProps,
  InputRightElement,
  useBreakpointValue,
  Text,
} from '@stockx/ui';
import React, { ChangeEvent, useState } from 'react';
import { useExperiment } from '@app/experiments';
import { EXPERIMENTS } from '@app/config';
import { CUSTOM_SUGGESTIONS_LIST } from './consts';
import {
  SearchInputWrapper,
  CustomPlaceholder,
  SuggestionList,
  SuggestionListItem,
} from './SearchInput.styles';

interface Props extends InputProps {
  onClose?: () => void;
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  resultsInline?: boolean;
}

const SearchInput = ({
  onClose,
  handleChange,
  resultsInline,
  ...props
}: Props) => {
  const [showCloseButton, setShowCloseButton] = useState(false);

  const { isMobile } = useBreakpointValue();
  const ab_pirate_searchbar_suggestions_web = useExperiment(
    EXPERIMENTS.ab_pirate_searchbar_suggestions_web,
  );

  const showSearchbarSuggestions =
    ab_pirate_searchbar_suggestions_web === 'true' &&
    !resultsInline &&
    !isMobile;

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (handleChange) {
      handleChange(e);
    }

    if (e.target.value) {
      setShowCloseButton(true);
    } else {
      setShowCloseButton(false);
    }
  };

  const handleClearSearch = () => {
    setShowCloseButton(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <SearchInputWrapper data-component="SearchInput">
      <InputLeftElement>
        <SearchIcon />
      </InputLeftElement>

      <Input
        onChange={handleInputChange}
        {...props}
        borderRadius="0"
        {...(showSearchbarSuggestions
          ? {
              placeholder: '',
            }
          : {})}
      />

      {showSearchbarSuggestions && !props?.value && (
        <CustomPlaceholder>
          <Text display="inline-block" verticalAlign="top">
            {'Search '}
          </Text>
          <SuggestionList display="inline-block">
            {CUSTOM_SUGGESTIONS_LIST.map((item) => (
              <SuggestionListItem
                key={`${item}`}
              >{`${item}`}</SuggestionListItem>
            ))}
          </SuggestionList>
        </CustomPlaceholder>
      )}

      {showCloseButton && !isMobile && (
        <InputRightElement>
          <CloseButton
            onClick={handleClearSearch}
            borderRadius="0"
            data-testid="SearchCloseBtn"
            _hover={{ background: 'transparent' }}
          />
        </InputRightElement>
      )}
    </SearchInputWrapper>
  );
};

export default SearchInput;
